/* eslint-disable array-callback-return */
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { renderDurationSeo } from '@/utils/renderDuration';
import { convertMoney } from '@/utils/convertMoney';
import { style } from '@/styles/globals';

export default function ListDetailVcms({
  dataObj, airlines, isDesktop, airlineSlug, lang,
}: any) {
  const mapping: { [key: string]: any } = {
    distance: lang?.GeneralInfo?.distance || 'Khoảng cách',
    average_duration: lang?.GeneralInfo?.timeOnTrip || 'Thời gian di chuyển',
    average_flight_count: lang?.GeneralInfo?.tripNumber || 'Số chuyến',
    airlines: lang?.GeneralInfo?.airlines || 'Hãng hàng không',
    lowest_price: lang?.GeneralInfo?.cheapestOneWayPrice || 'Giá vé một chiều rẻ nhất',
    lowest_round_flight_price: lang?.GeneralInfo?.cheapestRoundTripPrice || 'Giá vé khứ hồi rẻ nhất',
    average_price: lang?.GeneralInfo?.averagePrice || 'Giá vé trung bình',
  };

  const newData: any = {};
  newData.distance = (dataObj.distance || 0) ? `${dataObj.distance || 0}km` : '';
  newData.average_duration = dataObj.average_duration ? renderDurationSeo(dataObj.average_duration, lang) : '';
  newData.airlines = airlineSlug === 'pacific-airlines' ? 'Pacific Airlines' : (airlines || []).join(', ');
  newData.average_flight_count = dataObj.average_flight_count ? `${Math.round(
    dataObj.average_flight_count || 0,
  )} ${lang?.GeneralInfo?.tripNumberPerday || 'chuyến / ngày'}` : '';
  newData.lowest_price = dataObj.lowest_price ? convertMoney(dataObj.lowest_price, lang) : '';
  newData.lowest_round_flight_price = dataObj.lowest_round_flight_price ? convertMoney(
    dataObj.lowest_round_flight_price,
    lang,
  ) : '';
  newData.average_price = dataObj.average_price ? convertMoney(dataObj.average_price, lang) : '';

  return (
    <List
      sx={{
        width: '100%',
        bgcolor: 'background.paper',
        overflow: 'hidden',
        padding: 0,
        mt: 1,
        boxShadow: isDesktop ? '0px 2px 10px rgb(7 65 57 / 15%)' : 'none',
        borderRadius: isDesktop ? '6px' : 0,
      }}
    >
      {Object.keys(newData).map((key, i) => (
        <ListItem
          key={key}
          sx={{
            backgroundColor: i % 2 ? '#FFFFFF' : '#F9F9F9',
          }}
        >
          <ListItemText
            sx={{ width: '60%' }}
            primary={mapping[key]}
          />
          <ListItemText
            sx={{
              width: '40%',
              '& .MuiTypography-root': {
                ...style.text.content.regular,
                color: style.color.black2,
              },
            }}
            primary={newData[key]}
          />
        </ListItem>
      ))}
    </List>
  );
}
